import Alpine from "alpinejs";
import persist from "@alpinejs/persist";
import sort from "@alpinejs/sort";
import anchor from "@alpinejs/anchor";
import morph from '@alpinejs/morph'
import "./countdown";
import "./vote-formatter";
import "./otp";
import "./writeinSelector";
import "./video-carousel"
import "./utils"
import "htmx.org";
import htmx from "htmx.org";
import Swal from "sweetalert2";
import "htmx-ext-sse";
import "htmx-ext-head-support"; 
// import 'htmx-ext-alpine-morph'
import { Temporal, toTemporalInstant } from '@js-temporal/polyfill';

Date.prototype.toTemporalInstant = toTemporalInstant;
window.Temporal = Temporal

window.htmx = htmx;
window.Swal = Swal;

htmx.config.responseHandling = [
  { code: "204", swap: false }, // 204 - No Content by default does nothing, but is not an error
  { code: "[23]..", swap: true }, // 200 & 300 responses are non-errors and are swapped
  { code: "[45]..", swap: false, error: true}, // 400 & 500 responses are not swapped and are errors
  { code: "...", swap: false }, // catch all for any other response code
];


Alpine.plugin(morph)
Alpine.plugin(persist);
Alpine.plugin(sort);
Alpine.plugin(anchor);

window.Alpine = Alpine;
Alpine.start();

// --- CSRF token handling ---
let csrfToken =
  document.querySelector('meta[name="csrf-token"]')?.content || "";

const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
// Attach token to every htmx request
document.addEventListener("htmx:configRequest", (event) => {
  if (csrfToken) {
    event.detail.headers["X-CSRF-Token"] = csrfToken;
  }

  // Get the IANA timezone string and inject it into the headers
  event.detail.headers['X-Timezone'] = userTz;
});

function createAlert(message, level) {
  const alertNode = document.createElement("div")
  alertNode.className = `alert alert-${level} alert-soft`
  alertNode.role = "alert"

  // SVG icon
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg")
  const path = document.createElementNS("http://www.w3.org/2000/svg", "path")

  switch (level) {
    case "success":
      svg.setAttribute("xmlns", "http://www.w3.org/2000/svg")
      svg.setAttribute("class", "h-6 w-6 shrink-0 stroke-current")
      svg.setAttribute("fill", "none")
      svg.setAttribute("viewBox", "0 0 24 24")
      path.setAttribute("stroke-linecap", "round")
      path.setAttribute("stroke-linejoin", "round")
      path.setAttribute("stroke-width", "2")
      path.setAttribute("d", "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z")
      break
      
    case "error":
      svg.setAttribute("xmlns", "http://www.w3.org/2000/svg")
      svg.setAttribute("class", "h-6 w-6 shrink-0 stroke-current")
      svg.setAttribute("fill", "none")
      svg.setAttribute("viewBox", "0 0 24 24")
      path.setAttribute("stroke-linecap", "round")
      path.setAttribute("stroke-linejoin", "round")
      path.setAttribute("stroke-width", "2")
      path.setAttribute("d", "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z")
      break
    
    default:

  }
  svg.appendChild(path)
  alertNode.appendChild(svg)

  // Message
  const span = document.createElement("span")
  span.textContent = message
  alertNode.appendChild(span)

  // Close button
  const btn = document.createElement("button")
  btn.type = "button"
  btn.className = `btn btn-sm btn-ghost btn-${level}`
  btn.setAttribute("aria-label", "Close alert")
  btn.textContent = "✕"
  btn.addEventListener("click", () => alertNode.remove())
  alertNode.appendChild(btn)

  return alertNode
}

document.body.addEventListener("htmx:responseError", (event) => {
  // Handle errors differently
  const detail = event.detail
  if (detail.xhr.status >= 400) {
    // Remove any previous errors
    const errorsContainer = document.querySelector("#errors");

    let responseText = detail.xhr.responseText

    const parser = new DOMParser();
    const doc = parser.parseFromString(responseText, 'text/html');

    const errorContent =  doc.querySelector(".error")
    if (errorContent) {
      responseText = errorContent.textContent
    }

    // Create a DOM node instead of using a string
    const alertNode = createAlert(responseText, "error");
    errorsContainer.prepend(alertNode);

    // Prevent htmx from inserting the broken HTML
    event.preventDefault();
  }
})

function addSuccessAlert(evt) {
  const detail = evt.detail
  // Remove any previous errors
  const errorsContainer = document.querySelector("#errors");

  // Create a DOM node instead of using a string

  let responseText = detail.xhr.responseText

  const parser = new DOMParser();
  const doc = parser.parseFromString(responseText, 'text/html');

  const errorContent =  doc.querySelector(".error")
  if (errorContent) {
    responseText = errorContent.textContent
  }

  const alertNode = createAlert(responseText, "success");
  errorsContainer.prepend(alertNode);
}

window.addSuccessAlert = addSuccessAlert

// Update token whenever the server sends a new one
document.addEventListener("htmx:afterOnLoad", (event) => {
  const newToken = event.detail.xhr.getResponseHeader("X-CSRF-Token");
  if (newToken) {
    csrfToken = newToken;

    document.querySelector('meta[name="csrf-token"]').content = csrfToken;
  }
});

// Automatically attach CSRF token to normal HTML form submissions
document.querySelectorAll("form").forEach((form) => {
  form.addEventListener("submit", (e) => {
    // Skip if a hidden CSRF field already exists
    if (!form.querySelector('input[name="gorilla.csrf.Token"]')) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "gorilla.csrf.Token";
      input.value = csrfToken;
      form.appendChild(input);
    }
  });
});

document.addEventListener("htmx:afterSettle", () => {
  document.querySelectorAll("form").forEach((form) => {
    if (!form.dataset.csrfBound) {
      form.dataset.csrfBound = "true";
      form.addEventListener("submit", (e) => {
        if (!form.querySelector('input[name="gorilla.csrf.Token"]')) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = "gorilla.csrf.Token";
          input.value = csrfToken;
          form.appendChild(input);
        }
      });
    }
  });
});
